module.exports = __webpack_public_path__ + "media/components/assets/icons/insta_footer-9de19e9b0ba6cc134ce7d30c948450a5.svg";